export enum UserTypeEnum {
  Staff = 'staff',
  Resident = 'resident',
  FamilyHubMember = 'familyHubMember',
  Kiosk = 'kiosk'
}